

export class EditStackElement {
  beforeVersionId:number|undefined;
  beforeCursorState:any;
  afterCursorState:any;
  afterVersionId = -1;
  editOperations = [];
  constructor(json:any){
    for (let key in json){
      const lax: any = this;
      lax[key] = json[key];
    }

  }
  undo(model:any) {
    const lax: any = this;
    for (var i = lax.editOperations.length - 1; i >= 0; i--) {
      lax.editOperations[i] = {
        operations: model.applyEdits(lax.editOperations[i].operations)
      };
    }
  }
  redo(model:any) {
    const lax: any = this;
    for (var i = 0; i < lax.editOperations.length; i++) {
      lax.editOperations[i] = {
        operations: model.applyEdits(lax.editOperations[i].operations)
      };
    }
  }
}